import { Keys, Scene, Vector } from "excalibur";
import HoneyStand from "../actors/honeyStand";
import { gameState, inventoryState } from "../state/stateManager";
import { goToScene } from "../main";
import { checkFirstSale, sendAlert } from "../utils";
import { Resources } from "../Resources";
import InventoryHUD from "../ui/inventory";

export default class ManageStand extends Scene {
  constructor() {
    super();
    this.honeyStand = new HoneyStand({ x: 320, y: 160 }, this);
    this.honeyStand.scale = new Vector(4, 4);
    this.add(this.honeyStand);
    this.active = 0;

    this.selected = false;
    this.cashout = false;
    this.restocking = false;
  }
  onActivate() {
    this.restocking = false;
    this.inventory = inventoryState.getInventory();
    if (this.inventory.filledJars > 12) {
      this.jarsToAdd = 12;
    } else {
      this.jarsToAdd = this.inventory.filledJars;
    }

    this.menuContainer = document.getElementById("hive-menu-container");
    this.menuContainer.style.display = "flex";
    this.menu = document.getElementById("feed-menu");
    console.log("menu: ", this.menu);
    this.menu.style.display = "block";
    this.drawMenu();
    this.inventoryHUD = new InventoryHUD();
  }
  drawMenu() {
    console.log("inside drawmenu: ", this.active);
    if (this.active == 0) {
      this.menu.innerHTML = `<h1>Honey Stand</h1>
        <h1>Jars: ${this.inventory.honeyStand.jars}</h1>
        <h1>Coins: ${this.inventory.honeyStand.coins}</h1>
        <ul>
            <li id="list0"><span id="selector">></span>Restock</li>
            <li id="list1">Cash Out</li>
          
          </ul>
       
        `;
    } else if (this.active == 1) {
      this.menu.innerHTML = `<h1>Honey Stand</h1>
        <h1>Jars: ${this.inventory.honeyStand.jars}</h1>
        <h1>Coins: ${this.inventory.honeyStand.coins}</h1>
        <ul>
            <li id="list0">Restock</li>
            <li id="list1"><span id="selector">></span>Cash Out</li>
          
          </ul>
       
        `;
    }
  }
  onPostUpdate() {
    if (this.engine.input.keyboard.wasPressed(Keys.Up)) {
      Resources.Click.play();
      if (this.restocking) {
        if (this.jarsToAdd + 1 < this.inventory.filledJars) {
          if (this.jarsToAdd + 1 <= 12) {
            this.jarsToAdd++;
            this.openRestockMenu();
          } else {
            sendAlert("12 Jar Limit");
          }
        } else {
          sendAlert("Not Enough Jars");
        }
      } else {
        if (this.active == 0) {
          this.active = 1;
        } else {
          this.active = 0;
        }
        this.drawMenu();
      }
    }
    if (this.engine.input.keyboard.wasPressed(Keys.Down)) {
      Resources.Click.play();
      if (this.restocking) {
        this.jarsToAdd = this.jarsToAdd - 1;
        this.openRestockMenu();
      } else {
        console.log("active : ", this.active);
        if (this.active == 0) {
          this.active = 1;
        } else {
          this.active = 0;
        }
        this.drawMenu();
      }
    }
    if (this.engine.input.keyboard.wasPressed(Keys.Enter)) {
      if (this.active == 0) {
        //restock
        this.selected = true;
        this.restocking = true;
        this.openRestockMenu();
      } else if (this.active == 1) {
        //cash out
        this.selected = true;
        this.cashout = true;
        this.openCashoutMenu();
      }
    }
    if (this.engine.input.keyboard.wasPressed(Keys.X)) {
      if (this.selected) {
        this.drawMenu();
        this.restocking = false;
        this.cashout = false;
        this.selected = false;
      } else {
        goToScene("home");
      }
    }
    if (this.engine.input.keyboard.wasPressed(Keys.Space)) {
      console.log(
        "space: restocking: ",
        this.restocking,
        " cashOut: ",
        this.cashout
      );
      if (this.restocking) {
        if (this.inventory.honeyStand.jars + this.jarsToAdd <= 12) {
          this.inventory.filledJars =
            this.inventory.filledJars - this.jarsToAdd;
          this.inventory.honeyStand.jars =
            this.inventory.honeyStand.jars + this.jarsToAdd;
          this.inventory.honeyStand.lastMutated = new Date().getTime();
          inventoryState.setInventory(this.inventory);
          this.honeyStand.graphics.use("stocked");
          Resources.Inventory.play();
          this.inventoryHUD.display();
          sendAlert(`Restocked ${this.jarsToAdd} Jars`);
        } else {
          Resources.Error.play();
          sendAlert("12 Jar Limit");
        }
      } else if (this.cashout) {
        let coins = gameState.getCoins();
        console.log(
          "honeyStand: should cash out: ",
          this.inventory.honeyStand.coins,
          " coins: ",
          coins
        );
        coins = parseInt(coins) + parseInt(this.inventory.honeyStand.coins);
        Resources.Coins.play();
        gameState.setCoins(coins);
        checkFirstSale();
        sendAlert(`Cashed Out $${this.inventory.honeyStand.coins}`);
        this.inventory.honeyStand.coins = 0;
      }
    }
  }
  onDeactivate() {
    this.menuContainer.style.display = "none";
    this.menu.style.display = "none";
    this.inventoryHUD.destroy();
  }
  openCashoutMenu() {
    this.menu.innerHTML = `<h1>Honey Stand</h1>
    <h1>Jars: ${this.inventory.honeyStand.jars}</h1>
    <h1>Coins: ${this.inventory.honeyStand.coins}</h1>
    <h3>Cash In Box: ${this.inventory.honeyStand.coins}</h3><p>Hit Space To Cash Out</p><p>X> BACK</p>
   
    `;
  }
  openRestockMenu() {
    this.menu.innerHTML = `<h1>Honey Stand</h1>
    <h1>Jars: ${this.inventory.honeyStand.jars}</h1>
    <h1>Coins: ${this.inventory.honeyStand.coins}</h1>
    <h3>Jars To Restock ${this.jarsToAdd}</h3><p>Use Arrow Keys To Iterate</p><p>Hit Space To Restock</p><p>X> BACK</p>
   
    `;
  }
}
